import { ICON_BY_TYPE } from './PaymentMethodIcon.constants';
export function getIcon() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ICON_BY_TYPE[type.toLocaleLowerCase()] || null;
}